import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { CartService } from '../../../cart/services/cart.service';
import { SearchFilterService } from '../../../search-filter/services/search-filter.service';
import { CollectionsService } from '../../../collections/service/collections.service';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-layout-app',
  templateUrl: './layout-app.component.html',
  styleUrls: ['./layout-app.component.scss'],
})
export class LayoutAppComponent implements OnInit {
  cartOpen = false;
  searchActive = false;
  isAnonymous = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public searchFilterService: SearchFilterService,
    public cartService: CartService,
    private router: Router,
    private collectionsService: CollectionsService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const cartOpenSub = this.cartService.cartOpen$.subscribe((result) => {
      this.cartOpen = result;
    });
    this.subscriptions.add(cartOpenSub);
    if (
      !this.collectionsService._collectionsData ||
      !this.collectionsService.articlesData
    ) {
      if (this.router.url.endsWith('pages/privacy-policy')) {
        this.isAnonymous = true;
        return;
      }
      console.log('[Layout] init - navigate');
      this.router.navigate(['/pack-download'], {
        queryParams: {
          ...this.activatedRoute.snapshot.queryParams,
          origin: this.router.url,
        },
      });
    }
    if (this.router.url === '/search') {
      this.searchActive = true;
    }
  }

  prepareRoute(outlet: RouterOutlet): void {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
